import Menu from "./Menu";
import './Header.css';
function Header () {
    return (
        <header>
            <h1>Cruel Solitaire</h1>
            <Menu />
        </header>
    );
}

export default Header ;